/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path d="M1.7,15c-0.2,0-0.3-0.1-0.5-0.2C1.1,14.7,1,14.5,1,14.3L1.3,12c0-0.3,0.1-0.5,0.1-0.7 c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.3,0.4-0.5l6.8-6.8c0,0,0,0,0,0c0,0,0,0,0,0l2-2c1-1,2.6-1,3.6,0c1,1,1,2.6,0,3.6l-8.8,8.8 c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0.1-0.4,0.1-0.7,0.1L1.7,15C1.7,15,1.7,15,1.7,15z M9.3,4.9L3,11.3 c-0.2,0.2-0.2,0.2-0.3,0.3c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2-0.1,0.4l-0.2,1.4l1.4-0.2c0.2,0,0.3,0,0.4-0.1c0.1,0,0.1,0,0.2-0.1 c0.1,0,0.1-0.1,0.3-0.3l6.3-6.3L9.3,4.9z M10.3,4L12,5.7l1.5-1.5c0.2-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9 c-0.5-0.5-1.3-0.5-1.7,0L10.3,4z"/>'
  }
})